import Datepicker from 'vanillajs-datepicker/Datepicker';
import cs from 'vanillajs-datepicker/locales/cs';
import ru from 'vanillajs-datepicker/locales/ru';
Object.assign(Datepicker.locales, cs);
Object.assign(Datepicker.locales, ru);


const datePicker = {
    datePickersParentNode: [],
    datePickerFrom: [],
    datePickerTo: [],
   
    monthTranslate: {
        "cs": ["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],
        "en": ["January","February","March","April","May","June","July","August","September","October","November","December"],
        "de": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        "ru": ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"]
    },
    lang: null,

    init() {
        let self = this;
        let datePickerParentNodes = document.querySelectorAll('.js-datepicker');
    
        if ((datePickerParentNodes.length > 0)) {
            datePickerParentNodes.forEach((datePickerParentNode, index) => {
                if(! datePickerParentNode.classList.contains('js-datepicker-initialized')) {
                    self._constructDatepickers(datePickerParentNode, index);
                }
            });
        }
    },

    _constructDatepickers(datePickerParentNode, index) {
        let self = this;

        let datePickerFrom = datePickerParentNode.querySelector('.js-datepicker-from');
        let datePickerTo = datePickerParentNode.querySelector('.js-datepicker-to');
        self.lang = document.getElementsByTagName('html')[0].getAttribute('lang');

        self.datePickerFrom[index] =  new Datepicker(datePickerFrom, {
            language:  self.lang,
            format: 'yyyy-mm-dd',
            autohide: false,
            minDate: new Date(),
            defaultViewDate: new Date()
        });

        self.datePickerTo[index] = new Datepicker(datePickerTo, {
            language:  self.lang,
            format: 'yyyy-mm-dd',
            autohide: true,
            minDate: new Date().getTime()+(1*24*60*60*1000),
            defaultViewDate: new Date().getTime()+(2*24*60*60*1000)
        });

        datePickerParentNode.classList.add('js-datepicker-initialized');
        datePickerParentNode.dataset.id = index;

        self.datePickerFrom[index].setDate(new Date());
        self.datePickerTo[index].setDate(new Date().getTime()+(2*24*60*60*1000));

        self._updateValueFrom(self.datePickerFrom[index]);
        self._updateValueTo(self.datePickerTo[index]);        

        datePickerFrom.addEventListener('changeDate', () => {
            self._updateValueFrom(self.datePickerFrom[index]);
            self.datePickerTo[index].setOptions({minDate: new Date(self.datePickerFrom[index].getDate()).getTime()+(1*24*60*60*1000)});

            if(new Date(self.datePickerFrom[index].getDate()).getTime() > new Date(self.datePickerTo[index].getDate()).getTime()) {
                self.datePickerTo[index].setDate(new Date(self.datePickerFrom[index].getDate()).getTime()+(2*24*60*60*1000));
                setTimeout(() => {
                    self.datePickerTo[index].show();
                }, 100);
            }

            self.datePickerFrom[index].hide();
        });

        datePickerTo.addEventListener('changeDate', () => {
            self._updateValueTo(self.datePickerTo[index]);
        }); 
    },

    updateLink(node) {
        let self = this;
        let button = null;
        let datePicker = null;

        
        if(node.classList.contains('js-datepicker')) {
            button = node.querySelector('.js-reservation-button');
            datePicker = node;
        }
        else {
            datePicker = node.closest('.js-datepicker');
            button = datePicker.querySelector('.js-reservation-button');
        }

        let index = datePicker.dataset.id;
        let newURL = button.dataset.url;
        
        newURL = newURL.replace('[$dateFrom]', self._convertDate(self.datePickerFrom[index].getDate()));
        newURL = newURL.replace('[$dateTo]', self._convertDate(self.datePickerTo[index].getDate()));
        newURL = newURL.replace('[$personsCount]', self._getPersonCount(datePicker));
        newURL = newURL.replace('[$childrenCount]', self._getChildrenCount(datePicker));

        if(self._getPreferGroup(datePicker)) {
            newURL = newURL.replace('[$preferGroup]', self._getPreferGroup(datePicker));
        }
        
        button.href = newURL;
    },

    _updateValueFrom(datePickerFrom) {
        let self = this;
        
        if(datePickerFrom.getDate() !== undefined) {
            let dateObjectFrom = new Date(datePickerFrom.getDate());
            let fakePickerFrom = datePickerFrom.element.parentElement.querySelector('.js-fake-datepicker-from');
            fakePickerFrom.querySelector('.js-fake-datepicker__date').innerHTML = dateObjectFrom.getDate() + ' ' + self.monthTranslate[self.lang][dateObjectFrom.getMonth()];
        }

        self.updateLink(datePickerFrom.element.closest('.js-datepicker'));
    },

    _updateValueTo(datePickerTo) {
        let self = this;
        
        if(datePickerTo.getDate() !== undefined) {
            let dateObjectTo = new Date(datePickerTo.getDate());
            let fakePickerTo = datePickerTo.element.parentElement.querySelector('.js-fake-datepicker-to');
            fakePickerTo.querySelector('.js-fake-datepicker__date').innerHTML = dateObjectTo.getDate() + ' ' + self.monthTranslate[self.lang][dateObjectTo.getMonth()];
        }
        
       self.updateLink(datePickerTo.element.closest('.js-datepicker'));
    },

    _convertDate(date) {
        if(date !== undefined) {
            return date.getFullYear() + '-' + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-' + ((date.getDate()) < 10 ? '0' + (date.getDate()) : (date.getDate()));
        }
    
    },

    _getPersonCount(datePicker) {
        return datePicker.querySelector('.js-reservation-adults-count input').value;
    },

    _getChildrenCount(datePicker) {
        return datePicker.querySelector('.js-reservation-children-count input').value;
    },

    _getPreferGroup(datePicker) {
        return datePicker.querySelector('.reservation-panel select') ? datePicker.querySelector('.reservation-panel select').value : false;
    }
}

window.datePicker = datePicker;

window.datePicker.init();

document.addEventListener('LokiRequestEnd', function () {
    window.datePicker.init();
});
